import { motion } from 'framer-motion';
import { GsImage } from '@/components/help-center/latest-power-shared';
import { DEFAULT_FOOTER_PEEK_SMILIES } from '@/lib/site-defaults';
import { cn } from '@/lib/utils';

/** Layout fixo do arco — só os códigos dos smilies são customizáveis. */
const PEEK_LAYOUT = [
  { x: -72, y: 6, size: 46, z: 2, duration: 4.7, delay: 0.15, tilt: -8 },
  { x: -40, y: -8, size: 54, z: 4, duration: 5.1, delay: 0.35, tilt: -3 },
  { x: 0, y: -14, size: 62, z: 5, duration: 4.9, delay: 0.2, tilt: 1 },
  { x: 48, y: -9, size: 54, z: 4, duration: 5.3, delay: 0.5, tilt: 4 },
  { x: 82, y: -9, size: 68, z: 2, duration: 4.8, delay: 0.05, tilt: 9 },
] as const;

/** @deprecated Use DEFAULT_FOOTER_PEEK_SMILIES — mantido para coming soon. */
export const BRAND_PEEK_SMILIES = PEEK_LAYOUT.map((layout, i) => ({
  ...layout,
  code: DEFAULT_FOOTER_PEEK_SMILIES[i],
}));

type BrandPeekSmiliesProps = {
  className?: string;
  /** Escala visual do cluster (1 = tamanho da coming soon). */
  scale?: number;
  /** Códigos xat dos 5 smilies (esquerda → direita). */
  codes?: string[] | null;
};

function resolveCodes(codes?: string[] | null): string[] {
  const defaults = [...DEFAULT_FOOTER_PEEK_SMILIES];
  if (!Array.isArray(codes) || codes.length === 0) return defaults;
  return defaults.map((fallback, i) => {
    const raw = codes[i];
    if (typeof raw !== 'string') return fallback;
    const cleaned = raw.trim().toLowerCase().replace(/[^a-z0-9_]/g, '');
    return cleaned || fallback;
  });
}

export function BrandPeekSmilies({ className, scale = 1, codes }: BrandPeekSmiliesProps) {
  const resolved = resolveCodes(codes);

  return (
    <div className={cn('pointer-events-none', className)} aria-hidden>
      <div
        className="relative h-16 w-[240px]"
        style={
          scale !== 1
            ? { transform: `scale(${scale})`, transformOrigin: 'center bottom' }
            : undefined
        }
      >
        {PEEK_LAYOUT.map((item, index) => {
          const code = resolved[index] ?? DEFAULT_FOOTER_PEEK_SMILIES[index];
          return (
            <motion.div
              key={`${index}-${code}`}
              className="absolute -translate-x-1/2 -translate-y-1/2"
              style={{
                left: `calc(50% + ${item.x}px)`,
                top: `calc(50% + ${item.y}px)`,
                zIndex: item.z,
                width: item.size,
                height: item.size,
              }}
              animate={{ y: [0, -7, 0], rotate: [item.tilt, item.tilt + 2, item.tilt] }}
              transition={{
                duration: item.duration,
                delay: item.delay,
                repeat: Number.POSITIVE_INFINITY,
                ease: 'easeInOut',
              }}
            >
              <GsImage
                code={code}
                className={cn(
                  'flex h-full w-full items-center justify-center drop-shadow-[0_8px_16px_rgba(3,7,25,0.75)]',
                  item.z >= 5 ? 'brightness-110' : ''
                )}
                imgClassName="h-full w-full object-contain"
              />
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
